import React from 'react';
import PropTypes from 'prop-types';
import { uniqueId } from 'underscore';
import { Toggle } from '@fluentui/react/lib/Toggle';
import {
  useDefaultEditorStyle,
} from '@bingads-webui-campaign-react/smart-component-util';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

const getStyles = () => ({
  toggleContainer: {
    justifyContent: 'space-between',
  },
});

const UnstyledCustomizedToggle = ({
  i18n,
  classes,
  label,
  id,
  onToggle,
  defaultChecked,
  disabled,
}) => {
  const {
    sectionTitleClassName,
  } = useDefaultEditorStyle();

  return (
    <Toggle
      label={
        <span id={id} className={sectionTitleClassName}>{label}</span>
      }
      inlineLabel
      defaultChecked={defaultChecked}
      disabled={disabled}
      onText={i18n.getString(_TL_('Display on website'))}
      offText={i18n.getString(_TL_('Hidden on website'))}
      onChange={onToggle}
      className={classes.toggleContainer}
      ariaLabel={label}
    />
  );
};

UnstyledCustomizedToggle.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    toggleContainer: PropTypes.string.isRequired,
  }).isRequired,
  onToggle: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  id: PropTypes.string,
  defaultChecked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
};

UnstyledCustomizedToggle.defaultProps = {
  id: uniqueId('toggle_label_'),
};

export const CustomizedToggle = withDefaultStyles(
  UnstyledCustomizedToggle,
  getStyles
);
